// assets/clean-titles.js
(function () {
  const PHRASES = [
    /Extra\s+Large\s+Non[-\s]?Toxic\s+Eco[-\s]?Friendly\s+Stylish\s+Exercise\s+Mats?\s*&?\s*Play\s+Mats?/gi,
    /Non\s*Toxic\s*Eco\s*Friendly\s*Extra\s*Large\s*Exercise\s*Mat\s*and\s*Play\s*Mat/gi
  ];

  // Never modify text in breadcrumbs
  const IGNORE_CONTAINERS = [
    'nav[aria-label="Breadcrumbs"]',
    '.breadcrumbs'
  ];

  // Where we DO shorten titles (product cards, predictive search, etc.)
  const SELECTORS = [
    '.card__heading a',
    '.cart-item__name',
    '.cart-notification-product__name',
    '.predictive-search__item-heading',
    // product page titles (allowed unless explicitly opted out with data-no-clean)
    '.product__title h1',
    '.product__info-container h1',
    '.wk-product-title',
    '.wk_product_title'
  ];

  function isInsideIgnored(el) {
    return IGNORE_CONTAINERS.some(sel => el.closest(sel));
  }

  function clean(text) {
    if (!text) return text;
    let out = String(text);
    PHRASES.forEach(rx => { out = out.replace(rx, ''); });
    return out.replace(/\s{2,}/g, ' ').replace(/\s*&\s*/g, '&').trim();
  }

  function cleanNode(root) {
    if (!root) return;
    SELECTORS.forEach(sel => {
      root.querySelectorAll(sel).forEach(el => {
        if (isInsideIgnored(el)) return;
        if (el.hasAttribute('data-no-clean')) return;
        const before = el.textContent;
        const after = clean(before);
        if (before !== after) el.textContent = after;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => cleanNode(document));

  [
    'variant:change','variant:changed','swatchking:variantChanged',
    'shopify:section:load','shopify:section:reorder',
    'shopify:section:select','shopify:section:deselect'
  ].forEach(evt => {
    document.addEventListener(evt, () => cleanNode(document), true);
  });

  const obs = new MutationObserver(() => cleanNode(document));
  obs.observe(document.documentElement, { childList:true, characterData:true, subtree:true });
})();
